import { TabPanel } from '@warp-ds/react';
import { t } from 'shared/locale/texts';
import type { LevelFactory } from '@/components/factory';
import type { Vertical } from '@/data/verticals';

interface Props {
    factory: LevelFactory;
    vertical: Vertical;
}

export const Search = ({ factory, vertical }: Props) => {
    const { shortText, SearchComponent } = factory.menuValues();

    const createHeading = (destination: string) =>
        `${t(`heading.${vertical}.prefix`)} ${destination ? t(`heading.${vertical}.preposition`, { destination }) : t('heading.postfix')}`;

    return (
        <section data-testid="searchFormContent" aria-labelledby="main-heading">
            <h1 id="main-heading" className="sr-only">
                {createHeading(shortText)}
            </h1>
            <TabPanel name={vertical}>
                <SearchComponent />
            </TabPanel>
        </section>
    );
};
